import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Crown, X } from "lucide-react";
import { getRefCode } from "@/lib/referrals";

const DISMISS_KEY = "cc_referral_banner_dismissed_v1";

export default function ReferralBanner() {
  const [code, setCode] = useState("");
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const c = getRefCode();
    setCode(c);
    try {
      if (window.localStorage.getItem(DISMISS_KEY) === c) {
        setDismissed(true);
      } else {
        setDismissed(false);
      }
    } catch (_) {}
  }, [pathname]);

  if (!code || dismissed) return null;
  if (pathname.startsWith("/admin") || pathname.startsWith("/checkout")) return null;

  const handleDismiss = () => {
    try { window.localStorage.setItem(DISMISS_KEY, code); } catch (_) {}
    setDismissed(true);
  };

  return (
    <div
      data-testid="referral-banner"
      className="fixed top-0 left-0 right-0 z-[55] bg-[#824937]/95 backdrop-blur-md border-b border-[#D4AF37]/30 text-white"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-12 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <Crown className="w-3.5 h-3.5 text-[#D4AF37] flex-shrink-0" />
          <p className="text-[10px] md:text-xs uppercase tracking-[0.18em] truncate">
            Welcome — you were invited by a <span className="text-[#D4AF37]">Legacy Member</span>
            <span className="hidden md:inline text-white/60"> · ref {code}</span>
          </p>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          data-testid="referral-banner-dismiss"
          className="w-7 h-7 flex items-center justify-center text-white/70 hover:text-[#D4AF37] flex-shrink-0"
          aria-label="Dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
